import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo
} from 'react';
import ReactSearchBox from 'react-search-box';
import Kirk from './KirkComponent';
import Data from './DataComponent';
import Pro from './ProComponent';
import Header from './HeaderComponent';
// import Graph from './GraphComponent';
import Chronicle from './ChronicleComponent';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  postKirk,
  fetchKirks,
  loginUser,
  pwChangeUser,
  signupUser,
  deleteKirk,
  updateKirk,
  logoutUser,
  postInput,
  fetchInputs,
  deleteInput,
  updateInput,
  postProInput,
  fetchProInputs,
  deleteProInput,
  updateProInput,
  updateProInputFields,
  forgotPassword
} from '../redux/ActionCreators';
import { actions } from 'react-redux-form';
import ListKirk from './ListKirkComponent';
import ListKirk2 from './ListKirk2Component';
import ListKirkPro from './ListKirkProComponent';
import ListData from './ListDataComponent';
import ListProData from './ListProDataComponent';
import Forgot from './ForgotComponent';
import Reset from './ResetComponent';
import ResetPassword from './ResetPasswordComponent';
import NavigationArrows from './NavigationArrowsComponent';
// App version - centralized for easy management
// v0.851: Click row to copy link to clipboard (turns blue when selected)
// v0.852: Add X buttons to clear input fields (except reason/condition), appear when row selected
// v0.853: Clipboard toggle (restore previous content on deselect) + stability improvements
// v0.854: Context menu on row select (Edit, Delete, Copy Link) - no auto clipboard copy
// v0.855: Context menu fixes - clear other rows when selecting, fixed positioning, minimal styling
// v0.856: Press-and-hold context menu, multiple row selection, blue menu background, reordered items
// v0.857: Fix row shifting - use portal for menu, always close on release, match row background color
// v0.858: Fix accidental copy - menu action only triggers after deliberate hover
// v0.859: Redesigned context menu - hold indicator ring, header with record name, keyboard shortcuts, spring animation, danger zone styling
// v0.860: Added icons to context menu items (Edit record, Copy link, Delete)
// v0.861: Added context menu to list view (ListKirk2, ListKirkPro), removed auto clipboard copy
// v0.862: Data form modernization - floating labels, right-aligned submit button with accent color, lighter title
// v0.863: Pro form modernization - pill badge, floating labels, filled condition grid, right-aligned submit
// v0.864: Edit modal modernization - styled header, floating labels, white fields on blue bg, Update/Cancel buttons (all 4 list views)
// v0.865: Replace press-and-hold context menu with menu button (⋮), remove old edit/delete buttons (all 4 list views)
// v0.866: Hamburger menu (☰) for all list views, menu aligned to top of cell, date inline with menu in ListKirk2
// v0.867: Fix stale display on iOS - persist input values in reason/condition fields to localStorage
// v0.868: Allow table styling attributes (border, style, cellpadding, etc.) in HTML content
// v0.869: Add CSS for tables with border attribute - auto cell borders and header styling
// v0.870: Paste images directly into cells (auto-resized/compressed to fit, with click-to-enlarge lightbox) across all 4 list views
// v0.871: Fix pagination - page-number clicks were silently swallowed by the internal-link click interceptor; reduce default page size to 100 for faster rendering
// v0.872: Copy-link now jumps to the item's actual page (with a DOM poll instead of a fixed delay) and search resets to page 1, so cross-page links and no-match searches no longer show a blank list
// v0.873: Fix deep links clicked from within the app (place/data cells) - internal navigation now uses react-router's navigate() instead of a raw history.pushState that left search params stale
// v0.874: Fix saves silently lost when backgrounding the app right after confirming - API requests now use keepalive so they survive the tab being backgrounded mid-request
// v0.875: Chronicle timeline now scrolls internally with a fixed height so the time axis stays visible, and its floating buttons moved below the header so they're no longer hidden behind the search box
// v0.876: removed the x-axis on the bottom of Chron
// v0.880: Links in reason/condition auto-open in a new tab (target="_blank" added automatically), fixed dead links in list view (contentEditable was blocking clicks), hamburger menu now floats while scrolling in ListData (matches ListPro)
// v0.881: Reason/condition fields now evaluate arithmetic typed inline (e.g. "1,000+1=1,001", comma thousands separators, chained calculations) - wired across every form, inline table cell, and edit modal (fixed gaps in ListKirk2/ListKirkPro inline editing and all four modals)
// v0.882: Up arrow now jumps to page 1 of the list (not just the top of whichever page happened to be showing) across all 4 list views, since deep links/reloads can land you mid-list; down arrow restores both the page and scroll offset you came from
// v0.890: Added a "Pin to top"/"Unpin" hamburger-menu item so any item can be forced to the top of the list regardless of sort order (Data, Pro, and both Kirk list views); fixed a pre-existing bug where saving an item with a large pasted image in reason/condition could silently fail with "Failed to fetch" (keepalive fetch now only used under the browser's ~64KB body limit)
// v0.891: Fixed the row context menu (Edit/Copy link/Pin/Delete) in the List views: near the top of the screen it could render partly behind the fixed header, and when opening upward on a roomy screen it would visibly jump into place right after its open animation (the animation and the position were fighting over the same CSS transform)
// v0.892: Added a pin-toggle button (top-right of the item list, next to the CSV download icon) to all 4 list views; turning it off ignores pinned items and shows the plain sort order instead, on by default, one shared setting across Data/Pro/List/S-S
// v0.893: Reason and condition columns (including condition1-20 in the Pro view) can now be resized by dragging their right edge, spreadsheet-style; each column resizes independently and its width is remembered per browser (Data and Pro views)
// v0.894: Column-resize handles now also appear on every row's cell border, not just the header, so a column can be resized from anywhere in the list without scrolling back to the top
// v0.895: Fixed column-resize handles not working on iPhone/touch - dragging used to trigger iOS's native text-selection callout instead of resizing; handles now respond to touch drags directly
// v0.896: Widened the resize handles and added a mirrored grab zone on the other side of each border, since the old hairline target was too small to hit reliably with a finger on a smaller screen (worked on iPad, not iPhone); a touch landing just past the line now still resizes correctly instead of hitting the neighboring cell
// v0.897: Fixed reason's column-resize handle silently doing nothing when a row had a pending unsaved edit in an embedded field (e.g. a checkbox pasted into reason) - a page-wide "click outside to confirm" listener was intercepting the resize touch/click before the handle itself ever saw it and popping a confirm() dialog instead
// v0.898: Fixed reason's width getting stuck on the Pro page - these tables don't force a fixed column layout, so a header button label like "reason" or "condition" has its own minimum width the browser won't shrink below; a width saved earlier (e.g. from testing before this feature worked right) could end up stored below that minimum, so small drags kept silently doing nothing since the visible width was already pinned wider than the stored number. Stored widths are now clamped back into a safe range on every read, and the minimum was raised to comfortably fit these labels
// v0.899: Fixed reason's width being unable to grow at all on the Pro page (not just shrink) - with this many columns, the browser was silently squeezing every resizable column below its requested width to make everything fit the table's own footprint, and squeezed columns with short labels (c1-c20) happened to land close to their true size while "reason" (a longer label) landed visibly short of it. The table now sizes itself to fit every column's real requested width instead of compressing them
// v0.900: Reason/condition columns go back to auto-sizing to their content by default (like before this feature existed) instead of always claiming a wide fixed width - an explicit width now only kicks in once you've actually dragged that specific column. Also shrank the resize-handle bar back down to its original thin size, since the wider one was intercepting horizontal swipes meant to scroll the list
// v0.901: Fixed columns being too wide again after the v0.900 fix - forcing the whole table wider (to stop columns being squeezed) had the side effect of sizing every column, including plain auto ones, to its fully-unwrapped content width instead of letting text wrap normally. The width is now applied to a small wrapper inside each resizable cell instead of the table or the cell itself, so a customized column can still grow or shrink reliably without affecting the table's overall sizing or any other column
// v0.902: Fixed the Pro page's hamburger menu silently doing nothing - a leftover reference to a since-removed table cell (from an earlier embedded-checkbox edit) could make the next click anywhere on the page, including the menu button, misfire into a "confirm changes" check for a cell that no longer existed. Also fixed the v0.901 wrapper div being picked up by an internal cell-tracking lookup meant for a different, inner div, which could corrupt a saved reason/condition value after editing an embedded checkbox/input inside it
// v0.903: Fixed the Pro page's hamburger menu becoming unclickable once scrolled far enough that the resize-enabled reason/condition columns visually overlapped it - gave the sticky menu cell a higher z-index so it always wins. Clicking a row to copy it into the form at top no longer copies the date, since duplicating a row almost always means entering a new date anyway. Fixed a bug where editing a condition field on the Pro page and clicking away could pop two "OK to change data?" dialogs in a row. Added a toggle button (next to "Show all") to turn manual column-width resizing on/off - off by default, so reason/condition columns auto-size to their content; turning it on restores whatever widths were set last time it was on
// v0.904: Fixed embedded textarea/input content in reason/condition fields (e.g. a running shopping-list memo) silently losing the most recently typed text on iPhone - the code that captures its value when you tap elsewhere was reading it a moment too early, before the keyboard's IME had committed the last in-progress word/conversion into the field, so tapping away right after typing could drop exactly what you just added
// v0.905: Added LaTeX support to reason/condition fields on both Data and Pro pages - wrap math in $...$ for inline or $$...$$ (on its own lines) for a centered block. Also fixed a longstanding bug where pressing Enter while editing reason (and Data's condition) did nothing at all instead of adding a new line, silently collapsing any multi-line text you typed onto a single line - which was also why a $$ block never worked before this fix
// v0.906: Fixed reason/condition fields showing old content again after waking your phone - a leftover mechanism from before was caching every embedded field's text in the browser by its position on screen (not by what record it belonged to), then blindly pasting that cached text back in whenever the tab became visible again, no matter how stale it was. Removed it entirely, since the real editing flow was never affected by the iOS bug it was originally meant to work around
// v0.907: Fixed the search box reverting to an old keyword after reloading the browser instead of staying as it was right before the reload - a second, separate "remember the keyword" mechanism in the search box (independent of the one that already persists it per page) could resurrect a stale value on the very first load, and a keyword left over in the address bar from a detail-page link could likewise outlive clearing the box and reappear on reload. The search box now trusts a single source of truth, and the address bar's keyword is kept in sync as you type or clear it
// v0.908: Fixed embedded input and textarea values in ListData and ListPro disappearing or reverting after app suspension by keeping their HTML values current and saving pending cell edits when the page is backgrounded or closed
// v0.909: Inline Pro edits now send only the changed field, so overlapping saves can't erase other condition fields with stale row values
// v0.910: Save ListPro embedded HTML controls when their value is committed, including checkbox, select, text, and time inputs
// v0.911: Pass the partial-save action through the Pro page so embedded HTML control changes actually reach the server
// v0.912: Keep all embedded ListPro HTML control edits pending for the same click-away confirmation before saving
// v0.920: Stop storing plaintext passwords in localStorage and Redux auth state while preserving username and login persistence
// v0.921: Secure password resets with single-use expiring tokens, account validation, and revocation of existing sessions after reset
export const APP_VERSION = '0.921';

const mapStateToProps = state => ({
  kirks: state.kirks,
  auth: state.auth,
  inputs: state.inputs,
  proInputs: state.proInputs
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  fetchKirks: () => dispatch(fetchKirks()),
  fetchInputs: () => dispatch(fetchInputs()),
  fetchProInputs: () => dispatch(fetchProInputs()),
  resetKirkForm: () => dispatch(actions.reset('kirk')),
  resetInputForm: () => dispatch(actions.reset('input')),
  resetProInputForm: () => dispatch(actions.reset('proInput')),
  loginUser: creds => dispatch(loginUser(creds)),
  pwChangeUser: creds => dispatch(pwChangeUser(creds)),
  signupUser: creds => dispatch(signupUser(creds)),
  logoutUser: () => dispatch(logoutUser()),
  forgotPassword: email => dispatch(forgotPassword(email)),
  postKirk: (
    date,
    place,
    person,
    subject,
    reason,
    how,
    data,
    work,
    news,
    buy,
    utilities,
    events,
    health,
    foods,
    invests
  ) =>
    dispatch(
      postKirk(
        date,
        place,
        person,
        subject,
        reason,
        how,
        data,
        work,
        news,
        buy,
        utilities,
        events,
        health,
        foods,
        invests
      )
    ),
  postInput: (date, place, person, subject, reason, condition, data, unit) =>
    dispatch(
      postInput(date, place, person, subject, reason, condition, data, unit)
    ),
  postProInput: (
    date,
    place,
    person,
    subject,
    reason,
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
    condition6,
    condition7,
    condition8,
    condition9,
    condition10,
    condition11,
    condition12,
    condition13,
    condition14,
    condition15,
    condition16,
    condition17,
    condition18,
    condition19,
    condition20,
    data,
    unit
  ) =>
    dispatch(
      postProInput(
        date,
        place,
        person,
        subject,
        reason,
        condition1,
        condition2,
        condition3,
        condition4,
        condition5,
        condition6,
        condition7,
        condition8,
        condition9,
        condition10,
        condition11,
        condition12,
        condition13,
        condition14,
        condition15,
        condition16,
        condition17,
        condition18,
        condition19,
        condition20,
        data,
        unit
      )
    ),
  deleteKirk: kirkId => dispatch(deleteKirk(kirkId)),
  deleteInput: inputId => dispatch(deleteInput(inputId)),
  deleteProInput: proInputId => dispatch(deleteProInput(proInputId)),
  updateKirk: (
    kirkId,
    date,
    place,
    person,
    subject,
    reason,
    how,
    data,
    work,
    news,
    buy,
    utilities,
    events,
    health,
    foods,
    invests
  ) =>
    dispatch(
      updateKirk(
        kirkId,
        date,
        place,
        person,
        subject,
        reason,
        how,
        data,
        work,
        news,
        buy,
        utilities,
        events,
        health,
        foods,
        invests
      )
    ),
  updateInput: (
    inputId,
    date,
    place,
    person,
    subject,
    reason,
    condition,
    data,
    unit,
    pinned
  ) =>
    dispatch(
      updateInput(
        inputId,
        date,
        place,
        person,
        subject,
        reason,
        condition,
        data,
        unit,
        pinned
      )
    ),
  updateProInput: (
    inputId,
    date,
    place,
    person,
    subject,
    reason,
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
    condition6,
    condition7,
    condition8,
    condition9,
    condition10,
    condition11,
    condition12,
    condition13,
    condition14,
    condition15,
    condition16,
    condition17,
    condition18,
    condition19,
    condition20,
    data,
    unit,
    pinned
  ) =>
    dispatch(
      updateProInput(
        inputId,
        date,
        place,
        person,
        subject,
        reason,
        condition1,
        condition2,
        condition3,
        condition4,
        condition5,
        condition6,
        condition7,
        condition8,
        condition9,
        condition10,
        condition11,
        condition12,
        condition13,
        condition14,
        condition15,
        condition16,
        condition17,
        condition18,
        condition19,
        condition20,
        data,
        unit,
        pinned
      )
    ),
  updateProInputFields: (inputId, fields) =>
    dispatch(updateProInputFields(inputId, fields))
});

// The problem: DataPage creates new refs and functions on every render
// This causes ListData to unmount/remount

// SOLUTION: Move scrollContainerRef and functions OUTSIDE of DataPage

// import React, { useState, useEffect, useRef, useCallback } from 'react';
// ... other imports stay the same

// MainComponent.js
// Move these component definitions BEFORE the Main component (outside of it)

// ... all your other imports

// ⭐ DEFINE THESE OUTSIDE OF Main ⭐
const DataPageWrapper = ({
  dispatch,
  resetInputForm,
  postInput,
  inputs,
  deleteInput,
  updateInput,
  keyword,
  auth,
  getDisplay,
  view,
  showAll,
  saveScrollPosition,
  restoreScrollPosition,
  scrollContainerRef,
  htmlResumeRevision,
  version
}) => {
  // Sample data for logged-out users to demonstrate app capabilities
  const sampleData = [
    {
      _id: 'sample1',
      date: '2025-5-9 Fri 10:00',
      place: 'Tokyo',
      person: 'Demo User',
      subject: 'Welcome to Kirk App!',
      reason:
        'This is a <b>sample entry</b> to show you what this app can do. You can <mark>highlight important text</mark> using HTML tags.<br><br><img src="https://picsum.photos/seed/welcome/200/120" alt="Sample Image" width="200"><br><i>You can also embed images!</i>',
      condition: 'Try it yourself',
      data: '100',
      unit: 'points',
      user: 'local'
    },
    {
      _id: 'sample2',
      date: '2025-5-8 Thu 14:30',
      place: 'Office',
      person: 'Team Lead',
      subject: 'Task Checklist Example',
      reason:
        '<b>Today\'s Tasks:</b><br><input type="checkbox"> Review documents<br><input type="checkbox" checked> Attend meeting<br><input type="checkbox"> Submit report',
      condition: 'In progress',
      data: '3',
      unit: 'tasks',
      user: 'local'
    },
    {
      _id: 'sample3',
      date: '2025-5-7 Wed 09:15',
      place: '東京',
      person: '田中さん',
      subject: '今日の予定（日本語サンプル）',
      reason:
        '<b>やることリスト：</b><ul><li><input type="checkbox" checked> 会議に参加する</li><li><input type="checkbox"> レポートを書く</li><li><input type="checkbox"> メールを送る</li></ul><mark>頑張りましょう！</mark><br><br><img src="https://picsum.photos/seed/tokyo/200/120" alt="Tokyo" width="200">',
      condition: '進行中',
      data: '3',
      unit: '件',
      user: 'local'
    },
    {
      _id: 'sample4',
      date: '2025-5-6 Tue 16:45',
      place: 'Gym',
      person: 'Trainer',
      subject: 'Workout Log',
      reason:
        '<mark>Morning Routine:</mark><br>- Push-ups: <b>30 reps</b><br>- Squats: <b>25 reps</b><br>- Plank: <b>60 sec</b>',
      condition: 'Completed',
      data: '45',
      unit: 'minutes',
      user: 'local'
    },
    {
      _id: 'sample5',
      date: '2025-5-5 Mon 11:00',
      place: 'Paris',
      person: 'Pierre',
      subject: 'Liste de courses (Exemple en français)',
      reason:
        '<b>Ingrédients pour le dîner:</b><ul><li><input type="checkbox" checked> Baguette</li><li><input type="checkbox" checked> Fromage</li><li><input type="checkbox"> Vin rouge</li><li><input type="checkbox"> Croissants</li></ul><mark>Bon appétit!</mark><br><br><img src="https://picsum.photos/seed/paris/200/120" alt="Paris" width="200">',
      condition: 'À acheter',
      data: '4',
      unit: 'articles',
      user: 'local'
    },
    {
      _id: 'sample6',
      date: '2025-5-4 Sun 20:00',
      place: 'Home',
      person: 'Family',
      subject: 'Movie Night Poll',
      reason:
        'Which movie to watch?<br><input type="checkbox"> Action<br><input type="checkbox" checked> Comedy<br><input type="checkbox"> Drama',
      condition: 'Voted',
      data: '3',
      unit: 'options',
      user: 'local'
    },
    {
      _id: 'sample7',
      date: '2025-5-3 Sat 08:30',
      place: 'Madrid',
      person: 'Carlos',
      subject: 'Mi rutina de ejercicios (Ejemplo en español)',
      reason:
        '<b>Ejercicios de hoy:</b><br><input type="checkbox" checked> Correr: <mark>30 minutos</mark><br><input type="checkbox" checked> Abdominales: <mark>50 repeticiones</mark><br><input type="checkbox"> Estiramientos<br><b>¡Vamos!</b><br><br><img src="https://picsum.photos/seed/madrid/200/120" alt="Madrid" width="200">',
      condition: 'En progreso',
      data: '45',
      unit: 'minutos',
      user: 'local'
    },
    {
      _id: 'sample8',
      date: '2025-5-2 Fri 13:00',
      place: 'Conference Room',
      person: 'Manager',
      subject: 'Meeting Action Items',
      reason:
        '<b>Follow-up required:</b><ul><li><input type="checkbox"> Send proposal by Monday</li><li><input type="checkbox"> Schedule client call</li><li><input type="checkbox" checked> Update project timeline</li></ul><br><img src="https://quickchart.io/chart?c={type:\'pie\',data:{labels:[\'Done\',\'Pending\'],datasets:[{data:[1,2],backgroundColor:[\'%2336a2eb\',\'%23ff6384\']}]}}&w=150&h=150" alt="Progress Chart" width="150">',
      condition: 'Urgent',
      data: '3',
      unit: 'items',
      user: 'local'
    },
    {
      _id: 'sample9',
      date: '2025-5-1 Thu 19:30',
      place: '서울',
      person: '김민수',
      subject: '오늘의 할 일 (한국어 예시)',
      reason:
        '<b>체크리스트:</b><ul><li><input type="checkbox" checked> 아침 운동하기</li><li><input type="checkbox" checked> 한국어 공부</li><li><input type="checkbox"> 친구 만나기</li></ul><mark>화이팅!</mark><br><br><img src="https://picsum.photos/seed/seoul/200/120" alt="Seoul" width="200">',
      condition: '진행 중',
      data: '3',
      unit: '개',
      user: 'local'
    },
    {
      _id: 'sample10',
      date: '2025-4-30 Wed 10:00',
      place: 'Online',
      person: 'Instructor',
      subject: 'Course Progress',
      reason:
        '<b>Completed Modules:</b><br><input type="checkbox" checked> Introduction<br><input type="checkbox" checked> Basics<br><input type="checkbox" checked> Intermediate<br><input type="checkbox"> Advanced<br><br><img src="https://quickchart.io/chart?c={type:\'bar\',data:{labels:[\'Intro\',\'Basic\',\'Inter\',\'Adv\'],datasets:[{label:\'Progress\',data:[100,100,100,0],backgroundColor:\'%2336a2eb\'}]}}&w=180&h=120" alt="Course Progress Chart" width="180">',
      condition: '75% done',
      data: '12',
      unit: 'lessons',
      user: 'local'
    },
    {
      _id: 'sample11',
      date: '2025-4-29 Tue 15:00',
      place: '北京',
      person: '李明',
      subject: '学习计划（中文示例）',
      reason:
        '<b>本周目标：</b><ul><li><input type="checkbox" checked> 阅读一本书</li><li><input type="checkbox"> 练习编程</li><li><input type="checkbox"> 学习英语</li></ul><mark>加油！</mark><br><br><img src="https://picsum.photos/seed/beijing/200/120" alt="Beijing" width="200">',
      condition: '努力中',
      data: '10',
      unit: '小时',
      user: 'local'
    },
    {
      _id: 'sample12',
      date: '2025-4-28 Mon 09:00',
      place: 'Desk',
      person: 'Developer',
      subject: 'Try Adding Your Own!',
      reason:
        'Use the form above to add your own entries. <b>They will be stored locally</b> until you refresh the page.<br><br><mark>Sign up to save your data permanently!</mark>',
      condition: 'Get started',
      data: '0',
      unit: 'entries',
      user: 'local'
    }
  ];

  // Local state for temporary data when logged out (initialized with samples)
  const [localInputs, setLocalInputs] = useState(sampleData);

  const isAuthenticated = auth.isAuthenticated;

  // Local postInput for logged-out users (adds to local state, not server)
  const localPostInput = useCallback(
    (date, place, person, subject, reason, condition, data, unit) => {
      let dateValue = date;
      if (!dateValue) {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1;
        const day = now.getDate();
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        const week = now.toLocaleDateString(undefined, { weekday: 'short' });
        dateValue = `${year}-${month}-${day} ${week} ${hour}:${minute}`;
      }

      const newEntry = {
        _id: Date.now().toString(),
        date: dateValue,
        place: place || '',
        person: person || '',
        subject: subject || '',
        reason: reason || '',
        condition: condition || '',
        data: data || '',
        unit: unit || '',
        user: 'local'
      };

      setLocalInputs(prev => [newEntry, ...prev]);
    },
    []
  );

  // Local deleteInput for logged-out users
  const localDeleteInput = useCallback(id => {
    setLocalInputs(prev => prev.filter(item => item._id !== id));
  }, []);

  // Local updateInput for logged-out users
  const localUpdateInput = useCallback(
    (id, date, place, person, subject, reason, condition, data, unit, pinned) => {
      setLocalInputs(prev =>
        prev.map(item =>
          item._id === id
            ? {
                ...item,
                date,
                place,
                person,
                subject,
                reason,
                condition,
                data,
                unit,
                pinned: pinned !== undefined ? pinned : item.pinned
              }
            : item
        )
      );
      return Promise.resolve();
    },
    []
  );

  // Determine which data and functions to use
  const effectivePostInput = isAuthenticated ? postInput : localPostInput;
  const effectiveDeleteInput = isAuthenticated ? deleteInput : localDeleteInput;
  const effectiveUpdateInput = isAuthenticated ? updateInput : localUpdateInput;

  let myInputs = [];
  if (isAuthenticated) {
    for (let i = 0; i < inputs.inputs.length; i++) {
      if (showAll) {
        myInputs = inputs.inputs;
        break;
      } else if (inputs.inputs[i].user === auth.id) {
        myInputs.push(inputs.inputs[i]);
      }
    }
  } else {
    myInputs = localInputs;
  }

  // ✅ Restore scroll AFTER data is loaded and rendered
  useEffect(() => {
    if (!inputs.isLoading && myInputs.length > 0) {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        restoreScrollPosition();
      });
    }
  }, [inputs.isLoading, restoreScrollPosition]);

  // Mock auth for local user (allows edit/delete)
  const effectiveAuth = isAuthenticated
    ? auth
    : { ...auth, id: 'local', isAuthenticated: false };

  return (
    <div>
      <Data
        dispatch={dispatch}
        resetInputForm={resetInputForm}
        postInput={effectivePostInput}
        isLoading={inputs.isLoading}
        updatingId={inputs.updatingId}
        inputCount={myInputs.length}
      />

      {/* Show logged out message under Submit button */}
      {!isAuthenticated && (
        <div className='container main' style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: 18,
              color: 'darkgrey',
              fontWeight: 'bold'
            }}
          >
            <p>&gt; Logged out.</p>
            <p>&gt; Please SIGN UP or LOG IN from the top menu.</p>
            <p>
              &gt; Below are sample entries to show what you can do with this
              app.
            </p>
            <p>
              &gt; Try adding your own data using the form above - it works
              locally!
            </p>
            <p>
              &gt; Note: Local data will be cleared when you refresh the page.
            </p>
          </span>
        </div>
      )}

      <div className='col-12 mt-3'>
        {view ? (
          <ListData
            resetInputForm={resetInputForm}
            inputs={myInputs}
            isLoading={isAuthenticated ? inputs.isLoading : false}
            errMess={isAuthenticated ? inputs.errMess : null}
            deleteInput={effectiveDeleteInput}
            updateInput={effectiveUpdateInput}
            keyword={keyword}
            auth={effectiveAuth}
            getDisplay={getDisplay}
            updatingId={inputs.updatingId}
            saveScrollPosition={saveScrollPosition}
            restoreScrollPosition={restoreScrollPosition}
            scrollContainerRef={scrollContainerRef}
            htmlResumeRevision={htmlResumeRevision}
            version={version}
            view={view}
          />
        ) : (
          <ListKirk2
            resetKirkForm={resetInputForm}
            kirks={myInputs}
            isLoading={isAuthenticated ? inputs.isLoading : false}
            errMess={isAuthenticated ? inputs.errMess : null}
            deleteKirk={effectiveDeleteInput}
            updateKirk={effectiveUpdateInput}
            keyword={keyword}
            auth={effectiveAuth}
            updatingId={inputs.updatingId}
            htmlResumeRevision={htmlResumeRevision}
            view={view}
          />
        )}
      </div>
    </div>
  );
};

const ProPageWrapper = ({
  dispatch,
  resetProInputForm,
  postProInput,
  proInputs,
  deleteProInput,
  updateProInput,
  updateProInputFields,
  keyword,
  auth,
  getDisplay,
  view,
  showAll,
  saveScrollPosition,
  restoreScrollPosition,
  scrollContainerRef,
  htmlResumeRevision,
  version
}) => {
  let myProInputs = [];
  for (let i = 0; i < proInputs.proInputs.length; i++) {
    if (showAll) {
      myProInputs = proInputs.proInputs;
      break;
    } else if (proInputs.proInputs[i].user === auth.id) {
      // ✅ Fixed: auth.id (not props.auth.id)
      myProInputs.push(proInputs.proInputs[i]);
    }
  }

  // ✅ Restore scroll AFTER data is loaded and rendered
  useEffect(() => {
    if (!proInputs.isLoading && myProInputs.length > 0) {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        restoreScrollPosition();
      });
    }
  }, [proInputs.isLoading, restoreScrollPosition]);

  return (
    <div>
      <Pro
        dispatch={dispatch}
        resetProInputForm={resetProInputForm}
        postProInput={postProInput}
        updatingId={proInputs.updatingId}
        inputCount={myProInputs.length}
      />
      <div className='col-12 mt-3'>
        {view ? (
          <ListProData
            resetProInputForm={resetProInputForm}
            proInputs={myProInputs}
            isLoading={proInputs.isLoading}
            errMess={proInputs.errMess}
            deleteProInput={deleteProInput}
            updateProInput={updateProInput}
            updateProInputFields={updateProInputFields}
            htmlResumeRevision={htmlResumeRevision}
            keyword={keyword}
            auth={auth}
            getDisplay={getDisplay}
            updatingId={proInputs.updatingId}
            saveScrollPosition={saveScrollPosition}
            restoreScrollPosition={restoreScrollPosition}
            scrollContainerRef={scrollContainerRef}
            version={version}
            view={view}
          />
        ) : (
          <ListKirkPro
            resetKirkForm={resetProInputForm}
            kirks={myProInputs}
            isLoading={proInputs.isLoading}
            errMess={proInputs.errMess}
            deleteKirk={deleteProInput}
            updateKirk={updateProInput}
            keyword={keyword}
            auth={auth}
            updatingId={proInputs.updatingId}
            htmlResumeRevision={htmlResumeRevision}
            view={view}
          />
        )}
      </div>
    </div>
  );
};
// NOW your Main component
const Main = props => {
  // Separate keyword states for each page
  const [dataKeyword, setDataKeyword] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;
    if (path === '/' || path === '/inputs') {
      return params.get('keyword') || localStorage.getItem('dataKeyword') || '';
    }
    return localStorage.getItem('dataKeyword') || '';
  });
  const [proKeyword, setProKeyword] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;
    if (path === '/proInputs') {
      return params.get('keyword') || localStorage.getItem('proKeyword') || '';
    }
    return localStorage.getItem('proKeyword') || '';
  });
  const [chronKeyword, setChronKeyword] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;
    if (path === '/chronicle') {
      return (
        params.get('keyword') || localStorage.getItem('chronKeyword') || ''
      );
    }
    return localStorage.getItem('chronKeyword') || '';
  });
  // Chronicle window state (start/end timestamps for zoom/position)
  const [chronWindow, setChronWindow] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;
    if (path === '/chronicle') {
      const start = params.get('start');
      const end = params.get('end');
      if (start && end) {
        return { start: parseInt(start, 10), end: parseInt(end, 10) };
      }
    }
    return null;
  });
  const chronWindowDebounceRef = useRef(null);
  const [showAll, setShowAll] = useState(() => {
    const saved = localStorage.getItem('showAll');
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [dataView, setDataView] = useState(() => {
    // Initialize from URL if present, otherwise from localStorage
    const params = new URLSearchParams(window.location.search);
    const urlView = params.get('view');
    if (urlView !== null) {
      return urlView === 'list';
    }
    const saved = localStorage.getItem('dataView');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [proView, setProView] = useState(() => {
    // Initialize from URL if present, otherwise from localStorage
    const params = new URLSearchParams(window.location.search);
    const urlView = params.get('view');
    if (urlView !== null) {
      return urlView === 'list';
    }
    const saved = localStorage.getItem('proView');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [display, setDisplay] = useState([]);

  const hasFetched = useRef(false);
  const [htmlResumeRevision, setHtmlResumeRevision] = useState(0);
  const refreshTimerRef = useRef(null);
  const refreshAfterResume = useCallback(() => {
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => {
      const path = window.location.pathname;
      let refreshRequest;
      if (path === '/proInputs' || path === '/chronicle') {
        refreshRequest = props.fetchProInputs();
      } else if (path === '/kirks') {
        refreshRequest = props.fetchKirks();
      } else if (path === '/' || path === '/inputs') {
        refreshRequest = props.fetchInputs();
      }

      if (refreshRequest && typeof refreshRequest.finally === 'function') {
        refreshRequest.finally(() => setHtmlResumeRevision(revision => revision + 1));
      }
    }, 300);
  }, [props.fetchKirks, props.fetchInputs, props.fetchProInputs]);
  const dataScrollContainerRef = useRef(null);
  const proScrollContainerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Update keyword and view when URL changes (for deep linking)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlKeyword = params.get('keyword');
    const urlView = params.get('view');

    // Handle keyword - apply to current page only
    if (location.pathname === '/proInputs') {
      if (urlKeyword !== null) {
        setProKeyword(urlKeyword);
      }
    } else if (location.pathname === '/chronicle') {
      if (urlKeyword !== null) {
        setChronKeyword(urlKeyword);
      }
    } else if (location.pathname === '/' || location.pathname === '/inputs') {
      if (urlKeyword !== null) {
        setDataKeyword(urlKeyword);
      }
    }

    // Handle view - apply to current page
    if (urlView !== null) {
      const viewValue = urlView === 'list';
      if (location.pathname === '/proInputs') {
        setProView(viewValue);
      } else if (location.pathname === '/' || location.pathname === '/inputs') {
        setDataView(viewValue);
      }
    }
  }, [location.search, location.pathname]);

  // Handle internal links without page reload
  useEffect(() => {
    const handleInternalLinkClick = event => {
      // Find if click was on an <a> tag or inside one
      const anchor = event.target.closest('a');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      // Try to parse the href as a URL
      let url;
      try {
        // Handle both relative and absolute URLs
        url = new URL(href, window.location.origin);
      } catch {
        return; // Not a valid URL
      }

      // Check if it's a same-origin link
      if (url.origin !== window.location.origin) return;

      // Define all internal app routes
      const internalRoutes = [
        '/',
        '/inputs',
        '/proInputs',
        '/kirks',
        '/chronicle',
        '/users/forgot-password'
      ];
      const isInternalRoute = internalRoutes.includes(url.pathname);

      if (!isInternalRoute) return;

      event.preventDefault();
      event.stopPropagation();

      const itemId = url.searchParams.get('id');
      const urlKeyword = url.searchParams.get('keyword');
      const urlView = url.searchParams.get('view');
      const urlStart = url.searchParams.get('start');
      const urlEnd = url.searchParams.get('end');

      // Build target path preserving all query parameters
      let targetPath = url.pathname;
      const params = new URLSearchParams();

      if (itemId) params.set('id', itemId);
      if (urlKeyword) params.set('keyword', urlKeyword);
      if (urlView) params.set('view', urlView);
      if (urlStart) params.set('start', urlStart);
      if (urlEnd) params.set('end', urlEnd);

      if (params.toString()) {
        targetPath += '?' + params.toString();
      }

      // Update state based on target page
      if (url.pathname === '/proInputs') {
        if (urlKeyword !== null) setProKeyword(urlKeyword || '');
        if (urlView !== null) setProView(urlView === 'list');
      } else if (url.pathname === '/chronicle') {
        if (urlKeyword !== null) setChronKeyword(urlKeyword || '');
        // Update Chronicle window state if start/end are provided
        if (urlStart && urlEnd) {
          setChronWindow({
            start: parseInt(urlStart, 10),
            end: parseInt(urlEnd, 10)
          });
        }
      } else if (url.pathname === '/' || url.pathname === '/inputs') {
        if (urlKeyword !== null) setDataKeyword(urlKeyword || '');
        if (urlView !== null) setDataView(urlView === 'list');
      }

      // Check if we're already on the target page
      const currentPath = location.pathname;
      const isSamePage =
        currentPath === url.pathname ||
        (currentPath === '/' && url.pathname === '/inputs') ||
        (currentPath === '/inputs' && url.pathname === '/');

      if (isSamePage && !itemId) {
        // Same page without item id - update URL via react-router so
        // useSearchParams() in the target component actually picks up the
        // change (a raw history.pushState wouldn't notify react-router,
        // leaving searchParams - and any deep-link logic reading it - stale)
        navigate(targetPath);
      } else if (isSamePage && itemId) {
        // Same page with item id - update URL via react-router, then scroll
        navigate(targetPath);
        // Scroll to the item after a short delay for DOM to update
        setTimeout(() => {
          const row =
            document.querySelector(`tr[data-row-id="${itemId}"]`) ||
            document.querySelector(`[data-item-id="${itemId}"]`);
          if (row) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Flash highlight effect
            row.style.backgroundColor = '#fffacd';
            setTimeout(() => {
              row.style.transition = 'background-color 0.5s';
              row.style.backgroundColor = '#d6eaf8';
            }, 500);
          }
        }, 300);
      } else {
        // Navigate to different page
        navigate(targetPath);

        // If there's an item id, scroll to it after navigation
        if (itemId) {
          setTimeout(() => {
            const row =
              document.querySelector(`tr[data-row-id="${itemId}"]`) ||
              document.querySelector(`[data-item-id="${itemId}"]`);
            if (row) {
              row.scrollIntoView({ behavior: 'smooth', block: 'center' });
              // Flash highlight effect
              row.style.backgroundColor = '#fffacd';
              setTimeout(() => {
                row.style.transition = 'background-color 0.5s';
                row.style.backgroundColor = '#d6eaf8';
              }, 500);
            }
          }, 300);
        }
      }
    };

    document.addEventListener('click', handleInternalLinkClick, true);
    return () => {
      document.removeEventListener('click', handleInternalLinkClick, true);
    };
  }, [navigate, location.pathname]);

  const saveDataScrollPosition = useCallback(() => {
    if (dataScrollContainerRef.current) {
      const scrollLeft = dataScrollContainerRef.current.scrollLeft;
      localStorage.setItem('horizontalScrollPosition', scrollLeft);
    }
  }, []);

  const restoreDataScrollPosition = useCallback(() => {
    const savedScrollPosition = localStorage.getItem(
      'horizontalScrollPosition'
    );
    if (dataScrollContainerRef.current && savedScrollPosition) {
      dataScrollContainerRef.current.scrollLeft = parseInt(
        savedScrollPosition,
        10
      );
    }
  }, []);

  const saveProScrollPosition = useCallback(() => {
    if (proScrollContainerRef.current) {
      const scrollLeft = proScrollContainerRef.current.scrollLeft;
      localStorage.setItem('horizontalScrollPositionPro', scrollLeft);
    }
  }, []);

  const restoreProScrollPosition = useCallback(() => {
    const savedScrollPosition = localStorage.getItem(
      'horizontalScrollPositionPro'
    );
    if (proScrollContainerRef.current && savedScrollPosition) {
      proScrollContainerRef.current.scrollLeft = parseInt(
        savedScrollPosition,
        10
      );
    }
  }, []);

  useEffect(() => {
    if (!hasFetched.current) {
      props.fetchKirks();
      props.fetchInputs();
      props.fetchProInputs();
      hasFetched.current = true;
    }
  }, [props.fetchKirks, props.fetchInputs, props.fetchProInputs]);

  // Refresh data when a page is restored from the browser's back/forward cache.
  useEffect(() => {
    const handlePageShow = event => {
      if (event.persisted) {
        setHtmlResumeRevision(revision => revision + 1);
        refreshAfterResume();
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [refreshAfterResume]);

  // Fix stale display on iOS Safari tab suspension
  // Force re-render every time page becomes visible again
  const [, forceUpdate] = useState(0);
  const appRootRef = useRef(null);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Page is becoming visible - force re-render
        forceUpdate(n => n + 1);
        setHtmlResumeRevision(revision => revision + 1);
        refreshAfterResume();

        // A re-render alone only touches the DOM where content actually
        // differs. Cells whose data never changed while backgrounded (e.g.
        // reason/condition, which are synced imperatively via innerHTML
        // rather than React-controlled children) are left untouched, so
        // iOS Safari can keep compositing the screenshot it cached before
        // the app was backgrounded. Force a real repaint of the whole page
        // by removing/reinserting the root node from the render tree -
        // synchronous, so the browser never actually paints the
        // intermediate 'display:none' state.
        const root = appRootRef.current;
        if (root) {
          // Use visibility, not display, to force the repaint: unlike
          // display:none, visibility:hidden never collapses the box or the
          // page's scrollable height, so the window's scroll position is
          // never disturbed in the first place (no jump-to-top-then-back).
          const prevVisibility = root.style.visibility;
          root.style.visibility = 'hidden';
          void root.offsetHeight;
          root.style.visibility = prevVisibility;
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refreshAfterResume]);

  useEffect(() => {
    const handleOnline = () => {
      setHtmlResumeRevision(revision => revision + 1);
      refreshAfterResume();
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, [refreshAfterResume]);

  useEffect(() => () => clearTimeout(refreshTimerRef.current), []);

  useEffect(() => {
    localStorage.setItem('showAll', JSON.stringify(showAll));
  }, [showAll]);

  // Persist keywords to localStorage
  useEffect(() => {
    localStorage.setItem('dataKeyword', dataKeyword);
  }, [dataKeyword]);

  useEffect(() => {
    localStorage.setItem('proKeyword', proKeyword);
  }, [proKeyword]);

  useEffect(() => {
    localStorage.setItem('chronKeyword', chronKeyword);
  }, [chronKeyword]);

  // Keep the URL's `keyword` param in sync with the active page's keyword state.
  // Without this, a stale `keyword` param left over from a deep link (e.g. a
  // detail-page back link) would outlive a clear/edit of the search box, and a
  // reload would read that stale URL param instead of the value actually shown
  // right before the reload.
  const hasSyncedKeywordUrl = useRef(false);
  useEffect(() => {
    if (!hasSyncedKeywordUrl.current) {
      hasSyncedKeywordUrl.current = true;
      return;
    }
    const path = location.pathname;
    let activeKeyword;
    if (path === '/proInputs') {
      activeKeyword = proKeyword;
    } else if (path === '/chronicle') {
      activeKeyword = chronKeyword;
    } else if (path === '/' || path === '/inputs') {
      activeKeyword = dataKeyword;
    } else {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    if (activeKeyword) {
      params.set('keyword', activeKeyword);
    } else {
      params.delete('keyword');
    }
    const query = params.toString();
    const newUrl = `${window.location.pathname}${query ? `?${query}` : ''}`;
    if (newUrl !== `${window.location.pathname}${window.location.search}`) {
      window.history.replaceState({}, '', newUrl);
    }
  }, [dataKeyword, proKeyword, chronKeyword, location.pathname]);

  useEffect(() => {
    localStorage.setItem('dataView', JSON.stringify(dataView));
  }, [dataView]);

  useEffect(() => {
    localStorage.setItem('proView', JSON.stringify(proView));
  }, [proView]);

  // Separate keyword setters for each page
  const getDataKeyword = useCallback(keyword => setDataKeyword(keyword), []);
  const getProKeyword = useCallback(keyword => setProKeyword(keyword), []);
  const getChronKeyword = useCallback(keyword => setChronKeyword(keyword), []);
  const getShowAll = showAll => setShowAll(showAll);
  const getDataView = view => setDataView(view);
  const getProView = view => setProView(view);
  const getDisplay = useCallback(display => setDisplay(display), []);

  // Use ref to access chronKeyword without causing callback recreation
  const chronKeywordRef = useRef(chronKeyword);
  useEffect(() => {
    chronKeywordRef.current = chronKeyword;
  }, [chronKeyword]);

  // Chronicle window change handler - updates URL with debounce (stable callback)
  const handleChronWindowChange = useCallback(windowState => {
    // Debounce URL updates to avoid too many history entries
    if (chronWindowDebounceRef.current) {
      clearTimeout(chronWindowDebounceRef.current);
    }
    chronWindowDebounceRef.current = setTimeout(() => {
      const params = new URLSearchParams();
      params.set('start', windowState.start.toString());
      params.set('end', windowState.end.toString());
      if (chronKeywordRef.current) {
        params.set('keyword', chronKeywordRef.current);
      }
      const newUrl = `/chronicle?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }, 500); // 500ms debounce
  }, []); // Empty deps - uses ref for chronKeyword

  // ⭐ USE useMemo TO PREVENT UNMOUNT/REMOUNT ON EVERY RENDER ⭐
  const DataPage = useMemo(
    () => (
      <DataPageWrapper
        dispatch={props.dispatch}
        resetInputForm={props.resetInputForm}
        postInput={props.postInput}
        inputs={props.inputs}
        deleteInput={props.deleteInput}
        updateInput={props.updateInput}
        keyword={dataKeyword}
        auth={props.auth}
        getDisplay={getDisplay}
        view={dataView}
        showAll={showAll}
        saveScrollPosition={saveDataScrollPosition}
        restoreScrollPosition={restoreDataScrollPosition}
        scrollContainerRef={dataScrollContainerRef}
        htmlResumeRevision={htmlResumeRevision}
        version={APP_VERSION}
      />
    ),
    [
      props.dispatch,
      props.resetInputForm,
      props.postInput,
      props.inputs,
      props.deleteInput,
      props.updateInput,
      dataKeyword,
      props.auth,
      getDisplay,
      dataView,
      showAll,
      saveDataScrollPosition,
      restoreDataScrollPosition,
      dataScrollContainerRef,
      htmlResumeRevision
    ]
  );

  const ProPage = useMemo(
    () => (
      <ProPageWrapper
        dispatch={props.dispatch}
        resetProInputForm={props.resetProInputForm}
        postProInput={props.postProInput}
        proInputs={props.proInputs}
        deleteProInput={props.deleteProInput}
        updateProInput={props.updateProInput}
        updateProInputFields={props.updateProInputFields}
        keyword={proKeyword}
        auth={props.auth}
        getDisplay={getDisplay}
        view={proView}
        showAll={showAll}
        saveScrollPosition={saveProScrollPosition}
        restoreScrollPosition={restoreProScrollPosition}
        scrollContainerRef={proScrollContainerRef}
        htmlResumeRevision={htmlResumeRevision}
        version={APP_VERSION}
      />
    ),
    [
      props.dispatch,
      props.resetProInputForm,
      props.postProInput,
      props.proInputs,
      props.deleteProInput,
      props.updateProInput,
      props.updateProInputFields,
      proKeyword,
      props.auth,
      getDisplay,
      proView,
      showAll,
      saveProScrollPosition,
      restoreProScrollPosition,
      proScrollContainerRef,
      htmlResumeRevision
    ]
  );

  const KirkPage = () => {
    let myKirks = [];
    for (let i = 0; i < props.kirks.kirks.length; i++) {
      if (showAll) {
        myKirks = props.kirks.kirks;
        break;
      } else if (props.kirks.kirks[i].user === props.auth.id) {
        myKirks.push(props.kirks.kirks[i]);
      }
    }

    return (
      <div>
        <Kirk
          resetKirkForm={props.resetKirkForm}
          postKirk={props.postKirk}
          isUpdating={props.kirks.isUpdating}
        />
        <div className='col-12 mt-3'>
          <ListKirk
            resetKirkForm={props.resetKirkForm}
            kirks={myKirks}
            isLoading={props.kirks.isLoading}
            errMess={props.kirks.errMess}
            deleteKirk={props.deleteKirk}
            updateKirk={props.updateKirk}
            keyword={dataKeyword}
            auth={props.auth}
            isUpdating={props.kirks.isUpdating}
          />
        </div>
      </div>
    );
  };

  // const GraphPage = () => <Graph />;

  // Memoize Chronicle page to prevent unmount/remount on every render
  const myChronProInputs = useMemo(() => {
    let result = [];
    for (let i = 0; i < props.proInputs.proInputs.length; i++) {
      if (showAll) {
        return props.proInputs.proInputs;
      } else if (props.proInputs.proInputs[i].user === props.auth.id) {
        result.push(props.proInputs.proInputs[i]);
      }
    }
    return result;
  }, [props.proInputs.proInputs, showAll, props.auth.id]);

  const ChroniclePage = useMemo(
    () => (
      <div>
        <Chronicle
          proInputs={myChronProInputs}
          keyword={chronKeyword}
          initialWindow={chronWindow}
          onWindowChange={handleChronWindowChange}
        />
      </div>
    ),
    [myChronProInputs, chronKeyword, chronWindow, handleChronWindowChange]
  );

  const ForgotPasswordPage = () => (
    <div>
      <Forgot forgotPassword={props.forgotPassword} />
    </div>
  );

  return (
    <div ref={appRootRef}>
      <Header
        auth={props.auth}
        loginUser={props.loginUser}
        pwChangeUser={props.pwChangeUser}
        signupUser={props.signupUser}
        logoutUser={props.logoutUser}
        kirks={props.kirks.kirks}
        inputs={props.inputs.inputs}
        getDataKeyword={getDataKeyword}
        getProKeyword={getProKeyword}
        getChronKeyword={getChronKeyword}
        dataKeyword={dataKeyword}
        proKeyword={proKeyword}
        chronKeyword={chronKeyword}
        getDataView={getDataView}
        getProView={getProView}
        display={display}
        showAll={showAll}
        setShowAll={setShowAll}
        dataView={dataView}
        setDataView={setDataView}
        proView={proView}
        setProView={setProView}
      />
      <NavigationArrows />
      <Routes>
        <Route path='/users/reset-password/:id/:token' element={<ResetPassword />} />
        <Route exact path='/' element={DataPage} />
        <Route exact path='/inputs' element={DataPage} />
        <Route exact path='/kirks' element={<KirkPage />} />
        <Route exact path='/proInputs' element={ProPage} />
        {/* <Route exact path='/graph' element={<GraphPage />} /> */}
        <Route exact path='/chronicle' element={ChroniclePage} />
        <Route
          exact
          path='/users/forgot-password'
          element={<ForgotPasswordPage />}
        />
      </Routes>
      {/* Persistent footer - always visible */}
      <footer
        style={{
          textAlign: 'center',
          padding: '10px',
          marginTop: '20px',
          color: '#999',
          fontSize: '12px'
        }}
      >
        v{APP_VERSION}
      </footer>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
